import { render, staticRenderFns } from "./on_sale_table1.vue?vue&type=template&id=fa4b7500&scoped=true&"
import script from "./on_sale_table1.vue?vue&type=script&lang=js&"
export * from "./on_sale_table1.vue?vue&type=script&lang=js&"
import style0 from "./on_sale_table1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./on_sale_table1.vue?vue&type=style&index=1&id=fa4b7500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4b7500",
  null
  
)

export default component.exports